import { Box } from '@mui/material';
import GrayLine from '../../@common/GrayLine';

const PortraitPageLines = ({
  col1,
  col2,
  repeatLines = true,
  singleColumn,
  rowPadding,
  rowMargin,
  isNarrow,
  paddingBtwnCols,
  marginTop = 35,
  width = 325,
  ...props
}: any) => {
  const marginTopLine = isNarrow ? 50 : marginTop;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: singleColumn ? 'center' : 'space-evenly',
        top: 162,
        margin: rowMargin || '25px 0',
        flexDirection: singleColumn ? 'column' : 'unset',
        padding: rowPadding || '18px'
      }}
      {...props}
    >
      <Box style={{ width: 'min-content' }}>
        <GrayLine isTop width={width} isNarrow={isNarrow} />
        <div>{col1}</div>
        <GrayLine width={width} isNarrow={isNarrow} />

        {repeatLines && (
          <Box style={{ marginTop: marginTopLine }}>
            <GrayLine isTop width={width} isNarrow={isNarrow} />

            <GrayLine width={width} isNarrow={isNarrow} />
          </Box>
        )}
      </Box>
      {!singleColumn && (
        <Box style={{ width: 'min-content', paddingLeft: paddingBtwnCols || 0 }}>
          <GrayLine isTop width={width} isNarrow={isNarrow} />
          <div>{col2}</div>
          <GrayLine width={width} isNarrow={isNarrow} />
          {repeatLines && (
            <Box style={{ marginTop: marginTopLine }}>
              <GrayLine isTop width={width} isNarrow={isNarrow} />

              <GrayLine width={width} isNarrow={isNarrow} />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default PortraitPageLines;
